export const account = {

    // --- My account (new settings screen: menu.vue + AccountWelcome.vue) ---
    mc_title: `Moje konto`,
    mc_subtitle: `Ustawienia konta i firmy`,
    mc_group_account: `Konto`,
    mc_home: `Start`,
    mc_mydata: `Moje dane`,
    mc_subscription: `Subskrypcja`,
    mc_billing: `E-fakturowanie`,
    mc_whatsapp: `WhatsApp Business`,
    mc_notifications: `Powiadomienia`,
    mc_team: `Zarządzanie zespołem`,
    mc_team_badge: `Nowość`,
    mc_integrations: `Integracje`,
    mc_hello: `Witaj`,
    mc_welcome_sub: `Witamy na koncie. W tym miejscu zarządza Pan/Pani danymi firmy oraz ustawieniami, z których korzysta system.`,
    mc_quick: `Szybki dostęp`,
    mc_card_account_title: `Ustawienia konta`,
    mc_card_account_desc: `Dane kontaktowe, język panelu i bezpieczeństwo.`,
    mc_card_subscription_desc: `Plan i rozliczenia subskrypcji.`,
    mc_card_billing_desc: `Wystawcy faktur i to, który z nich fakturuje dany obiekt.`,
    mc_card_whatsapp_desc: `Połączenie, przez które system rozmawia z gośćmi.`,
    mc_card_notifications_desc: `Które alerty są wysyłane i jakimi kanałami.`,
    mc_card_team_desc: `Zapraszanie współpracowników i zarządzanie ich uprawnieniami.`,
    mc_card_integrations_desc: `Połączenia z usługami zewnętrznymi.`,

  p1: `Zarządzaj kontem`,
  p2: `Ustawienia konta`,
  p3: `Język`,
  p4: `Logowanie i bezpieczeństwo`,
  p5: `Moja subskrypcja`,
  p6: `Dane do faktury`,
  p7: `WhatsApp Business`,
  p8: `Integracje`,
  p9: `Ustawienia konta`,
  p10: `Zarządzaj danymi kontaktowymi, na które będą przychodzić wszystkie wiadomości od WACheckin.`,
  p11: `Dane zostały zaktualizowane`,
  p12: `Język platformy`,
  p13: `Wybierz preferowany język panelu sterowania. To ustawienie nie wpływa na język check-in, który widzą goście, ponieważ zależy on od ustawień ich urządzenia.`,
  p14: `Wybierz język z listy`,
  p15: `Wybierz język`,
  p16: `Hiszpański`,
  p17: `Angielski`,
  p18: `Zaktualizuj język`,
  p19: `Język został zastosowany`,
  p20: `W tym miejscu można zaktualizować hasło, aby zadbać o bezpieczeństwo konta.`,
  p21: `Czy chcesz zmienić hasło?`,
  p22: `Zmień hasło`,
  p23: `Sprawdź pocztę`,
  p24: `Aby kontynuować zmianę hasła, sprawdź skrzynkę odbiorczą i postępuj zgodnie z instrukcjami`,
  p25: `Kontynuuj`,
  p26: `Ups! Wystąpił nieoczekiwany błąd`,
  p27: `Dane zostały zaktualizowane`,
  p28: `WhatsApp for Business`,
  p29: `Połącz konto WhatsApp Business z naszą platformą i wysyłaj wiadomości do gości bezpośrednio ze swojego spersonalizowanego numeru.`,
  p30: `Nie połączono żadnego konta.`,
  p31: `Połącz konto`,
  p32: `Konto`,
  p33: `Połączone`,
  p34: `Odłącz konto`,
  p35: `Wczytywanie informacji...`,
  p36: `Odłącz WhatsApp for Business`,
  p37: `Czy na pewno chce Pan/Pani odłączyć WhatsApp for Business i przestać wysyłać wiadomości do gości przez WhatsApp?`,
  p38: `Odłącz`,
  p39: `Konto WhatsApp Business zostało odłączone`,
  p40: `Nie udało się odłączyć konta WhatsApp Business, prosimy o kontakt ze wsparciem`,
  p41: `Numer telefonu`,
  p42: `Konto Facebook`,
  p43: `Dane firmy`,
  p44: `Trzeba mieć prawidłowy i unikalny numer telefonu, aby używać go z WhatsApp Business API.`,
  p45: `Otrzyma Pan/Pani kod weryfikacyjny, aby uwierzytelnić numer na naszej platformie.`,
  p46: `Firmowy numer telefonu musi być prawidłowym numerem, który spełnia kryteria platformy`,
  p47: `WhatsApp for Business.`,
  p48: `Otrzyma Pan/Pani kod weryfikacyjny, aby uwierzytelnić numer na naszej platformie.`,
  p49: `Wróć do statusu konta`,
  p50: `Kontynuuj`,
  p51: `Trzeba mieć osobiste konto na Facebooku (powiązane z firmowym adresem e-mail)`,
  p52: `Jeśli firmowe konto Facebook zostało już utworzone i połączone z tym systemem, trzeba je uwierzytelnić przed rozpoczęciem onboardingu, klikając Zaloguj się przez Facebook.`,
  p53: `Aby uwierzytelnić konto firmowe, otwórz`,
  p54: `ten link`,
  p55: `w osobnej karcie.`,
  p56: `Trzeba wygenerować kod w aplikacji uwierzytelniającej i wpisać go w polu „Wpisz kod”.`,
  p57: `Po potwierdzeniu można zamknąć tę kartę.`,
  p58: `Wróć do statusu konta`,
  p59: `Wstecz`,
  p60: `Kontynuuj`,
  p61: `Przygotuj dane firmy`,
  p62: `Trzeba mieć pod ręką informacje o firmie: nazwę prawną i adres firmy, a także nazwę konta firmowego w takiej formie, w jakiej ma być wyświetlana.`,
  p63: `Trzeba mieć działającą firmową stronę internetową.`,
  p64: `Konto należy jak najszybciej zweryfikować w Meta. Zweryfikowana firma może na początku wysyłać 1000 wiadomości dziennie. Bez weryfikacji Meta dezaktywuje konto.`,
  p65: `Zgodnie z polityką Meta niezweryfikowane konto firmowe można powiązać tylko z dwoma numerami. Zweryfikuj konto, aby powiązać je z większą liczbą numerów.`,
  p66: `Wróć do statusu konta`,
  p67: `Wstecz`,
  p68: `Kontynuuj`,
  p69: `Konto WhatsApp Business zostało połączone`,
  
  p70: `Rozliczenia`,
  p71: `Status`,
  p72: `Pobrana kwota`,
  p73: `Opłacone`,
  p74: `Oczekujące`,
  p75: `Zobacz fakturę`,
  p76: `Nie znaleziono żadnych rozliczeń`,
  p77:`Data`,
  p78: ``,
  p79: ``,
  p80: ``,
};
